/**
 * 描述：打开下拉菜单
 * 日期：2017-12-18
 * 作者：chenhao.
 */
angular.module("trsGroupOpenModule", [])
    .directive("trsGroupopen", ["$compile", "$timeout", function($compile, $timeout) {
        return {
            replace: false,
            restrict: "A",
            link: function(scope, $elem, $attr) {
                initStatus();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    bindClick();
                    bindBody();
                }
                /**
                 * [bindClick description] 绑定点击事件
                 * @return {[type]} [description]
                 */
                function bindClick() {
                    $elem.bind("click", function() {
                        $elem.addClass('open');
                    });
                }
                /**
                 * [bindBody description]给body绑定bind事件
                 * @return {[type]} [description]
                 */
                function bindBody() {
                    $("body").click(function(event) {
                        if (event.target === $elem[0] || event.target.parentElement === $elem[0]) return;
                       $elem.removeClass('open');
                    });
                }
            }
        };
    }]);